import React from 'react';
import { useLocation } from 'react-router-dom';

import { Button } from '@swyftx/aviary/atoms/Button';
import { FlexLayout } from '@swyftx/aviary/atoms/Layout/Flex';
import { Modal } from '@swyftx/aviary/atoms/Modal';
import { Body, Heading } from '@swyftx/aviary/atoms/Typography';
import { InformationFilled } from '@swyftx/aviary/icons/filled';

import { useAvo } from '@hooks/Avo/useAvo';

interface Props {
  open: boolean;
  setOpen: (open: boolean) => void;
  onConfirm: () => void;
}

export const HodlModal: React.FC<Props> = (props) => {
  const { open, setOpen, onConfirm } = props;
  const location = useLocation();

  const avo = useAvo();

  return (
    <Modal
      open={open}
      showCloseButton={false}
      onOpenChange={(e) => setOpen(e?.valueOf() ?? false)}
      position='dynamic'
      className='min-w-[100vw] md:!min-w-[345px] md:!max-w-[345px]'
    >
      <FlexLayout direction='column' spacing={24} className='p-16 md:p-24'>
        <FlexLayout direction='column' spacing={8} alignItems='center'>
          <InformationFilled className='mb-12 h-64 w-64 text-color-text-info' />

          <Heading size='h4' className='text-center'>
            Deactivate crypto transfers to increase your account security
          </Heading>
          <Body color='secondary' className='text-center'>
            By deactivating cryptocurrency transfers, all crypto <strong>deposits</strong> and{' '}
            <strong>withdrawals</strong> to or from your account will be blocked.
          </Body>
          <Body color='secondary' className='text-center'>
            You will still be able to buy and sell crypto within your account.
          </Body>
          <Body color='secondary' className='text-center'>
            Your request may take up to 24 hours to process. We will email you to confirm that your request has been
            completed.
          </Body>
          <Body color='secondary' className='text-center'>
            You can reactivate crypto transfers at any time by contacting customer support. You may be required to
            complete additional verification to reactivate crypto transfers.
          </Body>
        </FlexLayout>

        <FlexLayout direction='column' className='w-full justify-end' spacing={12}>
          <Button
            variant='filled'
            onClick={() => {
              avo.pretotypeModalCtaClick({ screen: location.pathname, pretotypeId: 'hodl_mode' });
              setOpen(false);
              onConfirm();
            }}
            size='lg'
          >
            Deactivate Crypto Transfers
          </Button>
          <Button variant='outlined' onClick={() => setOpen(false)} size='lg'>
            Cancel
          </Button>
        </FlexLayout>
      </FlexLayout>
    </Modal>
  );
};
